import { useContext } from 'react';
import { GoogleMapsContext } from '../contexts/googleMapsContext';

export const useGoogleMaps = () => {
  const ctx = useContext(GoogleMapsContext);
  if (!ctx) {
    // Retornar un valor por defecto en lugar de lanzar error
    console.warn('⚠️ useGoogleMaps usado fuera de GoogleMapsProvider');
    return { isLoaded: false, loadError: new Error('GoogleMapsProvider no encontrado') };
  }
  return ctx;
}; 